<form [formGroup]="propertyForm">
  <div class="row">
    <mat-form-field appearance="outline" class="column">
      <mat-label>Property appraiser office</mat-label>
      <mat-select formControlName="officeId" required placeholder="Select appraiser office">
        @for (office of appraiserOffices; track office.id) {
          <mat-option [value]="office.officeNumber">{{ office.name }}{{ office.county ? ' — ' + office.county : '' }}{{ office.officeNumber ? ' (' + office.officeNumber + ')' : '' }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="column">
      <mat-label>Jurisdiction / Municipality</mat-label>
      <mat-select formControlName="jurisdiction" required placeholder="Select jurisdiction">
        @for (j of jurisdictions; track j.id) {
          <mat-option [value]="j.name">{{ j.name }}</mat-option>
        }
      </mat-select>
      <!-- Was a mat-hint that the next row covered in narrow columns (QA 2026-09-30). -->
      <mat-icon matSuffix matTooltip="Set by staff — drives the distribution split" aria-hidden="false"
                aria-label="Set by staff — drives the distribution split">info_outline</mat-icon>
    </mat-form-field>
  </div>
  <div class="row">
    <mat-form-field appearance="outline" class="column">
      <mat-label>Rental property street address</mat-label>
      <input formControlName="street" matInput required>
    </mat-form-field>
  </div>
  <div class="row">
    <mat-form-field appearance="outline" class="column">
      <mat-label>Apt/Unit/Suite</mat-label>
      <input formControlName="aptUnitSuite" matInput>
    </mat-form-field>
  </div>
  <div class="row">
    <mat-form-field appearance="outline" class="column">
      <mat-label>City</mat-label>
      <input formControlName="city" matInput required>
    </mat-form-field>
    <mat-form-field appearance="outline" class="column">
      <mat-label>State</mat-label>
      <mat-select formControlName="state" placeholder="State">
        @for (state of states; track state) {
          <mat-option [value]="state.id">{{ state.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="column">
      <mat-label>Zip Code</mat-label>
      <input formControlName="zip" matInput required>
    </mat-form-field>
  </div>
  <div class="row">
    <mat-form-field appearance="outline" class="column">
      <mat-label>Started renting</mat-label>
      <input formControlName="started" matInput [matDatepicker]="startedRentingPicker" required>
      <mat-datepicker-toggle matIconSuffix [for]="startedRentingPicker"></mat-datepicker-toggle>
      <mat-datepicker #startedRentingPicker></mat-datepicker>
    </mat-form-field>
    <mat-form-field appearance="outline" class="column">
      <mat-label>Filing Frequency</mat-label>
      <mat-select formControlName="frequency" placeholder="Filing Frequency">
        <mat-option *ngFor="let freq of FrequencyLabelMap | keyvalue" [value]="freq.key">{{freq.value}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</form>
